<template>
  <svg fill="none" height="18" viewBox="0 0 18 18" width="18">
    <path
      d="M1.5 9H16.5"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
  </svg>
</template>

<script>
  export default {
    name: 'MinusIcon',
  };
</script>
